import { parseJSON } from "common/string-helper";

function isTagSelected(tagsSelected, category, tagItem){
    return tagsSelected[category].find(el => (el.name).toLowerCase() === tagItem.toLowerCase())
}

function removeTag(tagsSelected, category, tagToRemove) {
    return tagsSelected[category].filter((ele) => {
        return ele.name !== tagToRemove
    });
}

function countSelectedTags(udpatedTagsSelected){
    let numOfSelected = 0;
    for(let category in udpatedTagsSelected) {
        let value = udpatedTagsSelected[category];
        let arrLength = value.length
        numOfSelected += arrLength
    }

    return numOfSelected;
}


function saveRecipe(api, tagsSelected, category,addItem) {
    for (let i = 0; i < api.length; i++) {
        let recipe = api[i]
        let tagsArr = recipe[category]
        if (tagsArr) {
            let parsedJson = parseJSON(tagsArr);
            
            for(let i =0; i < parsedJson.length; i++) {
                let tag = parsedJson[i];
                if (isTagSelected(tagsSelected, category, tag)) {
                    addItem(recipe)
                }
            }
        }
    }
}

function clearRecipeSet(updated, recipes, setIsFilterRecipes){
    if (countSelectedTags(updated) === 0) {
        recipes.clear();
        setIsFilterRecipes(false);
    }
}

function removeRecipe(recipes,updatedTagSelection) { 
    recipes.forEach((recipe) => {
        let count = 0;
        for(let category in updatedTagSelection) {
            let tagsArr = updatedTagSelection[category];
            for(let ele of tagsArr) {
                let tag = ele.name;
                if(parseJSON(recipe[category].toLowerCase()).indexOf(tag.toLowerCase()) > -1) {
                    count++;
                } 
            }
        }

        if(count === 0) recipes.delete(recipe);
    });
}

export {
    isTagSelected,
    removeTag,
    countSelectedTags,
    saveRecipe,
    removeRecipe,
    clearRecipeSet,
}      
